import Axios from '@/Axios'

class HCHBPayorTypeService {
    async getHCHBPayorTypes(data = {}) {
        return await Axios.get('wms.wms.api.hchb_payor_type.get_hchb_payor_types', {
            params: data,
        })
    }
    async createHCHBPayorType(data) {
        return await Axios.post('wms.wms.api.hchb_payor_type.create_hchb_payor_type', data)
    }

    async getHCHBPayorType(hchbpayorTypeId) {
        return await Axios.get('wms.wms.api.hchb_payor_type.get_hchb_payor_type_by_id', { params: { hchb_payor_type: hchbpayorTypeId } })
    }

    async updateHCHBPayorType(data) {
        return await Axios.put(`wms.wms.api.hchb_payor_type.update_hchb_payor_type`, data)
    }
    async deleteHCHBPayorType(hchbPayorType) {
        const transformed_hchb_payor_type = hchbPayorType.map((item) => ({ name: item }))
        return await Axios.delete('wms.wms.api.hchb_payor_type.delete_hchb_payor_types', { data: { hchb_payor_type: transformed_hchb_payor_type } })
    }
}
export default new HCHBPayorTypeService()
